import { render, staticRenderFns } from "./SurchargeForm.vue?vue&type=template&id=5687e533"
import script from "./SurchargeForm.vue?vue&type=script&lang=js"
export * from "./SurchargeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports